import { useOktaAuth } from '@okta/okta-react';
import { useEffect, useState } from 'react';
import { getAuthIdentityFromTokens } from 'packages/lib/auth';
import { postAuthEvent } from 'packages/lib/metrics/auth-metrics';
import { logError } from 'packages/lib/utils/logger';

// Aug-20-2026 Used Cursor (Auto) to generate LoginCallbackWithMetrics

let handledRedirect = false;

/** In the base case, Okta callback routes just call from LoginCallback, imported from '@okta/okta-react'
 * Here we handle the redirect ourselves, so we can also post a 'login' metric event
 */
export function LoginCallbackWithMetrics(): JSX.Element | null {
  const { oktaAuth, authState } = useOktaAuth();
  const [callbackError, setCallbackError] = useState<Error | null>(null);

  useEffect(() => {
    if (handledRedirect) {
      return;
    }
    handledRedirect = true;

    void (async (): Promise<void> => {
      try {
        await oktaAuth.handleLoginRedirect();

        const tokens = await oktaAuth.tokenManager.getTokens();
        const identity = getAuthIdentityFromTokens(tokens);
        if (!identity) {
          logError('Failed to send login metric (auth identity missing)');
          return;
        }
        await postAuthEvent('login', identity, tokens.accessToken?.accessToken);
      } catch (err: unknown) {
        const error = err instanceof Error ? err : new Error(String(err));
        setCallbackError(error);
        logError(err);
      }
    })();
  }, [oktaAuth]);

  const displayError = callbackError ?? authState?.error;
  if (displayError) {
    return <p>{displayError.toString()}</p>;
  }

  return null;
}

export default LoginCallbackWithMetrics;
